import React from 'react'
import MethodMapping from '../Shared/MethodMapping/MethodMapping'

const ShippingMapping = ({ connectorId, instancesId }) => (
    <MethodMapping
        resource="shipping"
        title="Shipping Method Mapping"
        entityLabel="shipping method"
        emptyIcon="uil-truck"
        idPrefix="shipping"
        connectorId={connectorId}
        instancesId={instancesId}
    />
)

export default ShippingMapping
